import { makeAutoObservable, runInAction } from "mobx";
import { MenuItemType } from "../../schemas/menu";
import MenuService from "../../services/menu_service";

class MenuStore {
	constructor() {
		makeAutoObservable(this);
	}

	private _menuItems: MenuItemType[] | undefined = undefined;
	get menuItems() {
		if (!this._menuItems) this.getMenu();
		return this._menuItems;
	}
	set menuItems(d: MenuItemType[] | undefined) {
		this._menuItems = d;
	}
	private async getMenu() {
		const menuItems = await MenuService.getMenu();
		runInAction(() => (this.menuItems = menuItems));
	}
}
const menuStore = new MenuStore();
export default menuStore;
